import React from "react";
import { Icon } from "../StaleComponents";
import { FileButton, ActionIcon } from "@mantine/core";

const ImageButton = ({ setImages, images }) => {
  return (
    <>
      <FileButton
        onChange={(e) => setImages([...images, e])}
        accept="image/png,image/jpeg"
        multiple
        disabled={images.length > 4}
      >
        {(props) => (
          <ActionIcon {...props} size={"xs"} style={{ marginTop: "4px" }}>
            <Icon>image</Icon>
          </ActionIcon>
        )}
      </FileButton>
    </>
  );
};

export default ImageButton;
